import { Button, Text } from "components/commons";
import styles from "./delivery-logs-filter.module.scss";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { prettifyProductType } from "utils/pretty.utils";
import { dateFormat, dateTimeFormatV2, timeFormat } from "utils";
import { DateTime } from "enums";
import moment from "moment";

export const mapDataToList = ({ deliveryLog, onClickView }) => {
  const { deliveryId, shift, deliveredAt, poReferenceNumber, plateNumber, cashier, productType } =
    deliveryLog;

  const shiftDate = shift ? (
    <>
      <Text className={styles.td}>
        {shift?.startShift
          ? dateTimeFormatV2(shift?.startShift) + (shift?.endShift ? " - " : "")
          : ""}
      </Text>
      <Text className={styles.td}>{shift?.endShift ? dateTimeFormatV2(shift?.endShift) : ""}</Text>
    </>
  ) : (
    "--"
  );

  return {
    deliveryId: (
      <>
        <Text className={styles.td}>{deliveryId ?? ""}</Text>
      </>
    ),
    shiftDate: shiftDate,
    deliveredAt: (
      <>
        <Text className={styles.td}>{dateFormat(deliveredAt ?? "")}</Text>
        <Text className={styles.td}>{timeFormat(deliveredAt ?? "")}</Text>
      </>
    ),
    poReferenceNumber: (
      <>
        <Text className={styles.td}>{poReferenceNumber ?? "--"}</Text>
      </>
    ),
    plateNumber: (
      <>
        <Text className={styles.td}>{plateNumber ?? "--"}</Text>
      </>
    ),
    cashier: (
      <>
        <Text className={styles.td}>{cashier || "--"}</Text>
      </>
    ),
    productType: (
      <>
        <Text className={styles.td}>{prettifyProductType(productType) ?? ""}</Text>
      </>
    ),
    action: (
      <Button style={{ textDecoration: "none" }} link onClick={() => onClickView?.(deliveryId)}>
        <div
          style={{
            color: "#5349b7",
            fontWeight: "500",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <span>View</span>
          <NavigateNextIcon fontSize="small" />
        </div>
      </Button>
    ),
  };
};

export const mapFilterToRequest = (filterState) => {
  const { productType, startDate, endDate, ...fs } = filterState;

  return {
    ...fs,
    startDate: startDate ? moment(startDate).format(DateTime.K) : undefined,
    endDate: endDate ? moment(endDate).format(DateTime.L) : undefined,
    productType: !productType.isSelectedAll ? productType.value.join(",") : undefined,
  };
};
